import React from "react"

/**
 * Section for markdown content (prose)
 * applies max width and padding
 */
function Content({ className, html }) {
  return (
    <div className={`max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8 ${className}`}>
      <div
        className="max-w-4xl mx-auto prose text-justify prose-primary-dark md-content"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </div>
  )
}

export default Content
